var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monitor-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.4993 14.1667V17.5H7.49935V14.1667M4.33268 14.1667H15.666C16.5994 14.1667 17.0661 14.1667 17.4227 13.985C17.7363 13.8252 17.9912 13.5703 18.151 13.2567C18.3327 12.9001 18.3327 12.4334 18.3327 11.5V5.16667C18.3327 4.23325 18.3327 3.76654 18.151 3.41002C17.9912 3.09641 17.7363 2.84144 17.4227 2.68166C17.0661 2.5 16.5994 2.5 15.666 2.5H4.33268C3.39926 2.5 2.93255 2.5 2.57603 2.68166C2.26243 2.84144 2.00746 3.09641 1.84767 3.41002C1.66602 3.76654 1.66602 4.23325 1.66602 5.16667V11.5C1.66602 12.4334 1.66602 12.9001 1.84767 13.2567C2.00746 13.5703 2.26243 13.8252 2.57603 13.985C2.93255 14.1667 3.39926 14.1667 4.33268 14.1667Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.b1ee6b53a01980d8cf84891587b2bdce.svg";
export { ForwardRef as ReactComponent };